import { Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'table-datatable-firmware',
  templateUrl: './datatable-firmware.component.html',
  styleUrls: ['./datatable-firmware.component.scss'],
  imports: [MatIconModule, MatTooltip],
})
export class DatatableFirmwareComponent {
  value = input<string>();
  hasWrite = input<boolean>();
  hasNewerFirmware = input<boolean>();

  firmwareUpgrade = output<MouseEvent>();
}
